export enum LogoSizes {
    DEFAULT = 'default',
    LARGE = 'large',
}
